import React, {Component, lazy, Suspense} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Spinner from './Shared/Spinner';
import {AppConst, appRoutePath} from "./_helpers/AppConts";

const LoginPage = lazy(() => import('./Login/LoginPage'));

const Dashboard = lazy(() => import('./Dashboard/DashboardPage'));
const CheckinPage= lazy(() => import('./Checkin/CheckinPage'));
const CheckinDetailPage= lazy(() => import('./Checkin/CheckinDetailPage'));

const ApplyUsePointPage = lazy(() => import('./Checkin/ApplyUsePointPage'));

const MessageSendPage = lazy(() => import('./Message/SendPage'));
const MessagePresetsPage = lazy(() => import('./Message/PresetsPage'));
const MessageWelcomePage = lazy(() => import('./Message/WelcomePage'));
const MessageTempletePage = lazy(() => import('./Message/TempletePage'));
const HistorySendPage = lazy(() => import('./Message/HistorySendPage'));

const InboxPage = lazy(() => import('./Inbox/InboxPage'));

const ShortUrlPage = lazy(() => import('./ShortUrl/ShortUrlPage'));

const CustomerPage = lazy(() => import('./Customer/CustomerPage'));
const CustomerDetailPage = lazy(() => import('./Customer/CustomerDetailPage'));

const AppointmentAdminPage = lazy(() => import('./Appointment/AppointmentAdmin'));
const AppointmentBook = lazy(() => import('./Appointment/AppointmentBook'));

const CustomerGroupPage= lazy(() => import('./Customer/GroupCustomer/GroupPage'));
const CustomerGroupDetailPage = lazy(() => import('./Customer/GroupCustomer/GroupDetailPage'));

const ServicePage = lazy(() => import('./Service/ServicePage'));
const ServiceDetailPage = lazy(() => import('./Service/ServiceDetailPage'));

const PromoPage = lazy(() => import('./Promotion/PromoPage'));
const PromoDetailPage = lazy(() => import('./Promotion/PromoDetailPage'));

const StaffPage = lazy(() => import('./Employee/StaffPage'));
const StaffDetailPage = lazy(() => import('./Employee/StaffDetailPage'));

const HostedWidgetPage = lazy(() => import('./Tools/HostedWidgetPage'));
const StoreConfigPage = lazy(() => import('./Tools/StoreConfigPage'));
const SocialMediaPage = lazy(() => import('./Tools/SocialMediaPage'));

const StorePage = lazy(() => import('./Store/StorePage'));
const StoreDetailPage = lazy(() => import('./Store/StoreDetailPage'));

const UserPage = lazy(() => import('./UserPage/UserPage'));
const UserDetailPage = lazy(() => import('./UserPage/UserDetailPage'));

const ImagePage = lazy(() => import('./Image/ImagePage'));


const Error404 = lazy(() => import('./Error/Error404'));
const Error500 = lazy(() => import('./Error/Error500'));
const BlankPage = lazy(() => import('./Error/BlankPage'));

class AppRoutes extends Component {
  render () {
    if (!this.props.isAuthenticated || !this.props.user) {
      return (
          <Suspense fallback={<Spinner/>}>
            <Switch>
              <Route exact path={appRoutePath.LoginPage} component = { LoginPage } />
              <Redirect to={appRoutePath.LoginPage}/>
            </Switch>
          </Suspense>
      );
    }

    const isMaster = this.props.user && this.props.user.role === AppConst.RoleUser.ROLE_MASTER;
    const isAdmin = this.props.user && this.props.user.role === AppConst.RoleUser.ROLE_ADMIN;

    if (isMaster && !this.props.storeAccessed) {
      return (
          <Suspense fallback={<Spinner/>}>
            <Switch>
              <Route exact path={appRoutePath.StorePage} component = {StorePage}/>
              <Route exact path={appRoutePath.StoreDetailPage + "/:id"} component = {StoreDetailPage}/>
              <Redirect to={appRoutePath.StorePage}/>
            </Switch>
          </Suspense>
      );
    }

    return (
      <Suspense fallback={<Spinner/>}>
        <Switch>
          <Route exact path={appRoutePath.Dashboard} component={ Dashboard } />
          <Route exact path={appRoutePath.LoginPage} component = { LoginPage } />

          <Route exact path={appRoutePath.CheckInPage} component = {CheckinPage}/>
          <Route exact path={appRoutePath.CheckInDetailPage + '/:id'} component = {CheckinDetailPage}/>

          <Route exact path={appRoutePath.CheckInPage + '/:id/apply-use-point'} component = {ApplyUsePointPage}/>

          <Route exact path={appRoutePath.AppointmentAdminPage} component={AppointmentAdminPage}/>
          <Route exact path={appRoutePath.AppointmentBook} component={AppointmentBook}/>

          <Route exact path={appRoutePath.MessageSend} component = {MessageSendPage}/>
          <Route exact path={appRoutePath.MessagePresets} component = {MessagePresetsPage}/>
          <Route exact path={appRoutePath.MessageWelcome} component = {MessageWelcomePage}/>
          <Route exact path={appRoutePath.MessageTemplete} component = {MessageTempletePage}/>
          <Route exact path={appRoutePath.MessageReport} component = {HistorySendPage}/>

          <Route exact path={appRoutePath.InboxPage} component = {InboxPage}/>
          <Route exact path={appRoutePath.ShortUrl} component = {ShortUrlPage}/>

          <Route exact path={appRoutePath.CustomerPage} component = {CustomerPage}/>
          <Route path={appRoutePath.CustomerDetailPage + "/:id"} component = {CustomerDetailPage}/>

          <Route exact path={appRoutePath.CustomerGroupPage} component = {CustomerGroupPage}/>
          <Route path={appRoutePath.CustomerGroupDetailPage + "/:id"} component = {CustomerGroupDetailPage}/>

          <Route exact path={appRoutePath.ServicePage} component = {ServicePage}/>
          <Route path={appRoutePath.ServiceDetailPage + "/:id"} component = {ServiceDetailPage}/>

          <Route exact path={appRoutePath.PromoPage} component = {PromoPage}/>
          <Route path={appRoutePath.PromoDetailPage + "/:id"} component = {PromoDetailPage}/>


          <Route exact path={appRoutePath.StaffPage} component={StaffPage}/>
          <Route path={appRoutePath.StaffDetailPage + "/:id"} component={StaffDetailPage}/>

          {isMaster && <Route exact path={appRoutePath.StorePage} component = {StorePage}/>}
          {isMaster && <Route exact path={appRoutePath.StoreDetailPage + "/:id"} component = {StoreDetailPage}/>}
          {isAdmin  && <Route exact path={appRoutePath.StoreDetailPage + "/:id"} component = {StoreDetailPage}/>}

          {isMaster && <Route exact path={appRoutePath.HostedWidgetPage} component={HostedWidgetPage}/>}
          {isMaster && <Route exact path={appRoutePath.StoreConfigPage} component={StoreConfigPage}/>}
          {isMaster && <Route exact path={appRoutePath.SocialMediaPage} component={SocialMediaPage}/>}

          <Route exact path={appRoutePath.UserPage} component = {UserPage}/>
          <Route exact path={appRoutePath.UserDetailPage + "/:id"} component = {UserDetailPage}/>

          <Route path={appRoutePath.ImagePage} component = {ImagePage}/>
          <Route path={appRoutePath.Error404} component={ Error404 } />
          <Route path={appRoutePath.Error500} component={ Error500 } />
          <Route path={appRoutePath.BlankPage} component={ BlankPage } />

          <Route path="/" component={Dashboard }/>
        </Switch>
      </Suspense>
    );
  }
}

export default AppRoutes;
